import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

/**
 * Card "Double-Bezel" (técnica de soft-skill / taste-skill): un shell exterior con
 * hairline envuelve un core interior con radio concéntrico e inner-highlight. Da una
 * sensación de profundidad tipo hardware (placa dentro de bandeja) en vez de la card
 * plana genérica (borde + sombra + fondo) que se ve barata.
 *
 * Semilla reutilizable para el rediseño por pantalla (Fase 4). Acepta `sx` para el
 * shell e `innerSx` para el core, y `padding` para el espaciado interno.
 */
function PremiumCard({
  children = null,
  sx = {},
  innerSx = {},
  padding = { xs: 2.5, md: 3 },
  ...rest
}) {
  return (
    <Box
      sx={{
        p: 0.75,
        borderRadius: 4,
        backgroundColor: 'surface.overlay',
        border: '1px solid',
        borderColor: 'hairline.main',
        ...sx
      }}
      {...rest}>
      <Box
        sx={{
          p: padding,
          borderRadius: 3,
          backgroundColor: 'surface.raised',
          boxShadow: 'inset 0 1px 0 var(--otx-inner-highlight)',
          ...innerSx
        }}>
        {children}
      </Box>
    </Box>
  );
}

PremiumCard.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  innerSx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.object])
};

export default PremiumCard;
